// Paleta „Łódź po epidemii”: przygaszone zielenie, cegła, mokry beton. Kolory gruntu i dróg wg kodów kafelków.
import { G, O, R } from '../world/tiles.js';

export const GROUND: Record<number, string> = {
  [G.VOID]: '#050606', [G.GRASS]: '#2f3a26', [G.FOREST]: '#1e2a19', [G.FARMLAND]: '#3d3b25', [G.SAND]: '#5b5136',
  [G.WATER]: '#1a2a33', [G.CONCRETE]: '#3a3b3c', [G.PAVING]: '#363330', [G.CEMETERY]: '#2b3026', [G.PARK]: '#2a3a24',
  [G.RAILBED]: '#2f2b27',
};
export const ROAD: Record<number, string> = {
  [R.MAJOR]: '#212223', [R.STREET]: '#29292a', [R.DIRT]: '#4a3d2b', [R.PATH]: '#4b4535', [R.RAIL]: '#3b302a',
  [R.TRAM]: '#2c2c2d', [R.SIDEWALK]: '#4a4744',
};
export const WALL_TOP = '#6e3b2c';      // czerwona cegła łódzkich kamienic i fabryk
export const WALL_LEFT = '#4d2a20';
export const WALL_RIGHT = '#5e3326';
export const FLOOR = '#3b3530';
export const DOOR = '#c9a24a';
export const OBJECT_COLORS: Record<number, string> = {
  [O.WRECK]: '#5a2f24', [O.BARRICADE]: '#6a5a3a', [O.DEBRIS]: '#4d4a45', [O.LAMP]: '#8a8a7a', [O.BUSH]: '#25371f',
  [O.FENCE]: '#5b5a55',
};
export const MINIMAP_ROAD = '#9a948a';
